<script setup lang="ts">
import { useToast as usePrimeToast } from 'primevue/usetoast'
import { onMounted, ref } from '#imports'
import type { User } from '~/layers/cms/app/types/cmsTypes'

import { useDialog } from 'primevue/usedialog'
import ChangeUserEmailDialog from './changeUserEmailDialog.vue'
import ChangeUserPasswordDialog from './changeUserPasswordDialog.vue'
import AddUserDialog from './addUserDialog.vue'
import RemoveUserConfirmationDialog from './removeUserConfirmationDialog.vue'

import { FilterMatchMode } from '@primevue/core/api'
import { getUsersList } from '~/layers/cms/app/composables/cms'

const filters = ref({
  email: { value: null, matchMode: FilterMatchMode.CONTAINS }
})

const toast = usePrimeToast()

const users = ref<User[]>([])

const getUsers = async () => {
  const response = await getUsersList()
  if (!response.status_ok) {
    toast.add({
      severity: 'error',
      summary: 'Error',
      detail: 'Nie udało się pobrac listy userów',
      life: 3000
    })
  }
  users.value = response.data as User[]
}

onMounted(async () => {
  getUsers()
})

const choosenUserId = ref(null)
const dialog = useDialog()

const changeEmail = (userId: number) => {
  const choosenUserId = userId
  dialog.open(ChangeUserEmailDialog, {
    props: {
      header: 'Zmień email',
      modal: true
    },
    data: {
      choosenUserId: choosenUserId
    },
    onClose: () => {
      getUsers()
    }
  })
}

const changePassword = (userId: number) => {
  const choosenUserId = userId
  dialog.open(ChangeUserPasswordDialog, {
    props: {
      header: 'Zmień hasło',
      modal: true
    },
    data: {
      choosenUserId: choosenUserId
    },
    onClose: () => {
      getUsers()
    }
  })
}

const addUser = () => {
  dialog.open(AddUserDialog, {
    props: {
      header: 'Zmień email',
      modal: true
    },
    data: {
      choosenUserId: choosenUserId
    },
    onClose: () => {
      getUsers()
    }
  })
}

const removeUser = (userId: number) => {
  const choosenUserId = userId
  dialog.open(RemoveUserConfirmationDialog, {
    props: {
      header: 'Usun usera',
      modal: true
    },
    data: {
      choosenUserId: choosenUserId
    },
    onClose: () => {
      getUsers()
    }
  })
}
</script>

<template>
  <div
    v-if="users?.length"
    class="flex flex-col gap-4"
  >
    <DataTable
      v-model:filters="filters"
      :value="users"
      scrollable
    >
      <template #header>
        <div class="flex justify-start">
          <IconField>
            <InputIcon>
              <i class="pi pi-search" />
            </InputIcon>
            <InputText
              v-model="filters['email'].value"
              placeholder="Wyszukaj po email"
            />
          </IconField>
        </div>
      </template>
      <Column
        field="email"
        header="Email"
      />
      <Column class="w-24">
        <template #body="{ data }">
          <div class="flex flex-row gap-4 justify-end">
            <Button
              type="button"
              label="Zmień email"
              severity="secondary"
              class="text-nowrap"
              @click="changeEmail(data.id)"
            />
            <Button
              type="button"
              label="Zmień hasło"
              severity="secondary"
              class="text-nowrap"
              @click="changePassword(data.id)"
            />
            <Button
              type="button"
              label="Usuń"
              severity="secondary"
              @click="removeUser(data.id)"
            />
          </div>
        </template>
      </Column>
    </DataTable>

    <Button
      type="button"
      label="Dodaj"
      severity="secondary"
      @click="addUser"
    />
  </div>

  <div v-else>
    Nie załadowano userów
  </div>
</template>
